import { render, staticRenderFns } from "./score-detail.vue?vue&type=template&id=1a957b27&scoped=true&"
import script from "./score-detail.vue?vue&type=script&lang=js&"
export * from "./score-detail.vue?vue&type=script&lang=js&"
import style0 from "./score-detail.vue?vue&type=style&index=0&id=1a957b27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a957b27",
  null
  
)

export default component.exports